import styled from '@emotion/styled';
import { screenSizes } from '../Literals';

export const CcfFormLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem 1.25rem;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 0.5rem 0;
  text-align: left;
  box-sizing: border-box;

  @media only screen and (max-width: ${screenSizes.tablet}) {
    grid-template-columns: 1fr;
    gap: 0.875rem;
    max-width: 100%;
  }

  .ccf-form__photo,
  .ccf-form__birthdate,
  .ccf-form__actions,
  .ccf-form__meta,
  .ccf-form__extra,
  .ccf-form__section,
  .ccf-form__observations,
  .ccf-form__guest-summary,
  .ccf-form__error-heading {
    grid-column: 1 / -1;
  }

  .ccf-form__error-heading {
    color: #db2828;
    margin: 0;
    font-weight: 600;
  }

  .ccf-form__guest-summary {
    margin: 0.25rem 0 0.5rem;
  }

  .ccf-form__photo {
    display: flex;
    justify-content: center;
    margin-bottom: 0.25rem;
  }

  .ui.input,
  .ui.input.Registration__input,
  .ui.selection.dropdown.Registration__input {
    width: 100% !important;
    display: block !important;
    margin: 0 !important;
  }

  .ui.input > input {
    min-height: 2.75rem;
    width: 100%;
    box-sizing: border-box;
  }

  .ui.selection.dropdown {
    position: relative;
    min-height: 2.75rem;
  }

  .ui.selection.dropdown > .text,
  .ui.selection.dropdown > .default.text {
    width: 100%;
    box-sizing: border-box;
    padding-right: 2.5em;
  }

  .ui.selection.dropdown > .dropdown.icon {
    position: absolute;
    right: 1em;
    left: auto;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
    width: auto;
    height: auto;
    line-height: 1;
  }

  .ccf-form__birthdate label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.4rem;
    font-size: 0.9rem;
    color: #333;
  }

  .ccf-form__birthdate .SingleDatePicker {
    display: block;
    width: 100%;
  }

  .ccf-form__birthdate .SingleDatePickerInput {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 2.75rem;
    box-sizing: border-box;
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 22px;
    background: #fff;
    transition: border-color 0.15s ease;
  }

  .ccf-form__birthdate .SingleDatePickerInput:focus-within {
    border-color: #2596c2;
  }

  .ccf-form__birthdate .SingleDatePickerInput_calendarIcon {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin: 0 0 0 0.85rem;
    padding: 0;
    cursor: pointer;
  }

  .ccf-form__birthdate .SingleDatePickerInput_calendarIcon_svg {
    fill: #767676;
  }

  .ccf-form__birthdate .DateInput {
    flex: 1;
    display: block;
    width: auto;
    min-width: 0;
    margin: 0;
    padding: 0;
    background: transparent;
  }

  .ccf-form__birthdate .DateInput_input {
    width: 100%;
    min-height: 2.75rem;
    padding: 0.65rem 0.85rem 0.65rem 0.35rem;
    border: none;
    border-radius: 0;
    background: transparent;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.4;
    color: #333;
    box-sizing: border-box;
  }

  .ccf-form__birthdate .DateInput_input::placeholder {
    color: #a3a3a3;
    font-weight: 400;
  }

  .ccf-form__birthdate .DateInput_input__focused {
    border: none;
    outline: none;
    background: transparent;
  }

  .ccf-form__birthdate .SingleDatePicker_picker {
    z-index: 10;
  }

  .ccf-form__birthdate-hint {
    margin: 0.4rem 0 0;
    color: #666;
    font-size: 0.8rem;
    line-height: 1.45;
  }

  .ccf-form__birthdate--error label,
  .ccf-form__birthdate--error .ccf-form__birthdate-hint {
    color: #9f3a38;
  }

  .ccf-form__birthdate--error .SingleDatePickerInput {
    border-color: #e0b4b4;
    background: #fff6f6;
  }

  .ccf-form__birthdate--error .SingleDatePickerInput:focus-within {
    border-color: #db2828;
  }

  .ccf-form__meta {
    margin: 0;
    font-size: 0.95rem;
    color: #444;
  }

  .ccf-form__actions {
    margin-top: 0.25rem;
    text-align: center;
  }

  .ccf-form__actions .ui.button {
    margin-top: 0.25rem;
    min-width: 10rem;
  }

  .ccf-form__extra {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
`;
